import { StateFrame } from "./shapes";

/** `ilu-no-filters` (10259:23826): funil. */
export function SemFiltros() {
  return (
    <StateFrame>
      {({ x, y, stroke }) => (
        <g
          className={stroke}
          transform={`translate(${x} ${y})`}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7.5 9.5h25L22.8 21.8v8.4l-5.6 2.4V21.8L7.5 9.5Z" />
        </g>
      )}
    </StateFrame>
  );
}
